import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { GlobalPageHeaderComponent } from '../../../../../../../components/global-page-header/global-page-header.component';
import { LabelConfigurationComponent } from '../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { P00039AntenneTypeEnum } from '../../Enum/P00039AntenneTypeEnum';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { SwitchConfigurationComponent } from '../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';

@Component({
  selector: 'app-p00039-installation-couverture-bassin',
  templateUrl: './p00039-installation-couverture-bassin.component.html',
  styleUrls: ['./p00039-installation-couverture-bassin.component.scss'],
  imports: [
    IonFooter,
    IonButton,
    IonContent,
    HeaderConfigurationComponent,
    TranslatePipe,
    IonLabel,
    IonList,
    IonItem,
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    GlobalPageHeaderComponent,
    LabelConfigurationComponent,
    SwitchConfigurationComponent,
  ],
})
export class P00039InstallationCouvertureBassinComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039AntenneTypeEnum = P00039AntenneTypeEnum;
  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
